import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Main.css';
import smoothscroll from 'smoothscroll-polyfill'; // Import the smoothscroll polyfill
import Navbar from '../Navbar/Navbar';
import FooterSection from '../Footer/FooterSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Import the arrow-down icon
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';

smoothscroll.polyfill();

const Main = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const scrollToAboutSection = () => {
    const aboutSection = document.querySelector('.about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };



  return (
    <div className="container">
      <div className="background-image">
        <div className="phrases-wrap">
          <div className="mainLogo">
            {/* <img className="mainLogoImage" src={lukatLogo} alt="lukat" /> */}
          </div>

        </div>

      </div>
      <div className="about-section-wrap">
        <div className="about-section">
          <FooterSection />
        </div>
      </div>


    </div>

  );
}; 

export default Main;